export const isE2E = (): boolean => process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'e2e';

export const isTest = (): boolean => process.env['NODE_ENV'] === 'test';

export const isDev = (): boolean => process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'dev';

export const isServerSide = (): boolean => typeof window === 'undefined';

export const isCMSPreview = (): boolean => process.env['CONTENTFUL_PREVIEW'] === 'true';
